<template>
  <vs-card :class="[$route.params.course_open_type === 'preview' ? 'preview_card' : '']">
    <ul class="cstm_tab_ul" v-if="$route.params.course_id && $route.params.course_open_type!='preview'">
      <li @click="tab('desc')" :class="[desc ? 'active' : '']">Course Description</li>
      <li v-if="$route.params.course_class_type!='self_based'" @click="tab('schedule')" :class="[schedule ? 'active' : '']">Course Scheduling</li>
      <li @click="tab('enrollment')" :class="[enrollment ? 'active' : '']">Course Enrollment</li>
      <li @click="tab('settings')" :class="[settings ? 'active' : '']">Course Settings</li>
      <li @click="tab('content')" :class="[content ? 'active' : '']">Content</li>
      <li @click="tab('preview')" :class="[preview ? 'active' : '']">Preview</li>
    </ul>
    <div :class="[$route.params.course_id ? 'remove_wizard_header' : '']">
      <form-wizard
        shape="square"
        class="cstm_form_wizard course_builder_wizard"
        :class="[this.courseDetails.courseStructure.course_type.id === 1?'remove_scheduling_tab':'']"
        title=""
        subtitle=""
        stepSize="xs"
        color="rgb(var(--vs-primary))"
        ref="wizard"
      >

        <!-- Tab 1 -->
        <tab-content title="Course Description" v-show="desc">
          <Description @course="course" :courseId="courseId" :counter="counter" class="course_builder_wizard_self_based" />
        </tab-content>

        <!-- Tab 2 -->
          <tab-content title="Course Scheduling"  v-show="schedule">
              <CourseScheduling @nextTab="nextTab" :courseId="courseId" :counter="counter" @prevPage="prevPage" />
          </tab-content>

        <!-- Tab 3 -->
        <tab-content title="Course Enrollment" v-show="enrollment">
          <CourseEnrollment @nextTab="nextTab" :courseId="courseId" :counter="counter" @prevPage="prevPage" />
        </tab-content>

        <!-- Tab 4 -->
        <tab-content title="Course Settings" v-show="settings">
          <CourseSettings @nextTab="nextTab" :courseId="courseId" :counter="counter" @prevPage="prevPage" />
        </tab-content>

        <!-- Tab 5 -->
        <tab-content title="Content" v-show="content">
          <CourseContent @nextTab="nextTab" :courseId="courseId" :counter="counter" @prevPage="prevPage" />
        </tab-content>
         <div class="preview_tab_content" v-show="preview" v-if="$route.params.course_id">
          <CourseContent @nextTab="nextTab" :preview="preview" :courseId="courseId" :counter="counter" @prevPage="prevPage" />
        </div>

        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">

            <vs-button
              type="border"
              color="secondary"
              v-if="props.activeTabIndex != 0"
              @click.native="props.prevTab()"
              >Back</vs-button
            >
          </div>

            <!-- <vs-button
              v-if="props.activeTabIndex != 4"
              @click.native="props.nextTab()"
              >Next</vs-button
            > -->
           <!--  <vs-button
              v-if="props.activeTabIndex == 4"
              @click="submit"
              class="wizard-footer-right"
              >Skip</vs-button
            > -->
        </template>
      </form-wizard>
    </div>
  </vs-card>
</template>

<script>
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Description from './components/description.vue'
import CourseScheduling from './components/scheduling.vue'
import CourseEnrollment from './components/enrollment.vue'
import CourseSettings from './components/settings.vue'
import CourseContent from './components/content.vue'

export default {
  data () {
    return {
      courseId: this.$route.params.course_id ? this.$route.params.course_id : null,
      counter: 0,
      desc: true,
      schedule: false,
      enrollment: false,
      settings: false,
      content: false,
      preview: false,
      jumpBtn: false,
      tabIndex:null,
      courseDetails:{
        courseStructure:{
          course_type:{
            id:this.$route.params.course_class_type == 'self_based' ? 1 : 2
          }
        }
      }
    }
  },
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    Description,
    CourseScheduling,
    CourseEnrollment,
    CourseSettings,
    CourseContent
  },
  mounted () {
    if (this.$route.params.course_open_type === 'preview') {
      this.tab('preview')
    }
  },
  methods: {
    tab (type) {
      if (type === 'desc') {
        this.desc = true
        this.schedule = false
        this.enrollment = false
        this.settings = false
        this.content = false
        this.preview = false
        this.counter = 1
      } else if (type === 'schedule') {
        this.desc = false
        this.schedule = true
        this.enrollment = false
        this.settings = false
        this.content = false
        this.preview = false
        this.counter = 2
      } else if (type === 'enrollment') {
        this.desc = false
        this.schedule = false
        this.enrollment = true
        this.settings = false
        this.content = false
        this.preview = false
        this.counter = 3
      } else if (type === 'settings') {
        this.desc = false
        this.schedule = false
        this.enrollment = false
        this.settings = true
        this.content = false
        this.preview = false
        this.counter = 4
      } else if (type === 'content') {
        this.desc = false
        this.schedule = false
        this.enrollment = false
        this.settings = false
        this.content = true
        this.preview = false
        this.counter = 5
      } else if (type === 'preview') {
        this.desc = false
        this.schedule = false
        this.enrollment = false
        this.settings = false
        this.content = false
        this.preview = true
        this.counter = 6
        console.log('hii from preview', this.preview)
      }
    },
    course (data) {
      console.log(data)
      this.courseDetails = data
      if (this.$route.params.course_id) {
        this.courseId = this.$route.params.course_id
        this.counter = 2
        if (this.$route.params.course_class_type === 'self_based') {
          this.tab('enrollment')
        } else {
          this.tab('schedule')
        }

      } else {
        this.courseId = data.id
        this.counter++
        if (data.courseStructure.course_type.id === 1) {
          this.jumpBtn = true
          this.counter = 3
          this.$refs.wizard.nextTab()
          this.$refs.wizard.nextTab()
        } else {
          this.$refs.wizard.nextTab()
        }

      }

    },
    nextTab (data) {
      console.log(data)
      if (this.$route.params.course_id) {
        this.counter = data
        let type = ''
        if (data === 2) type = 'schedule'
        else if (data === 3) type = 'enrollment'
        else if (data === 4) type = 'settings'
        else if (data === 5) type = 'content'
        else if (data === 6) type = 'preview'
        this.tab(type)
      } else {
        this.counter++
        this.$refs.wizard.nextTab()
      }

    },
    prevPage (data) {
      this.counter = data
      console.log(this.courseDetails)
      if (this.courseDetails.courseStructure.course_type.id === 1) {
        this.$refs.wizard.prevTab()
        this.$refs.wizard.prevTab()
      } else {
        this.$refs.wizard.prevTab()
      }
    }
  }
}
</script>
<style>
 .course_builder_wizard .wizard-footer-left,
 .course_builder_wizard .wizard-footer-right {
   display: none;
 }
 .remove_wizard_header ul.wizard-nav {
   display: none;
 }
 .remove_scheduling_tab .wizard-navigation ul.wizard-nav li:nth-child(2) {
  position:relative;
  pointer-events: none;
 }
 .remove_scheduling_tab .wizard-navigation ul.wizard-nav li:nth-child(2)::before {
  content: "";
  width:100%;
  height:100%;
  background:rgba(0,0,0,0.01);
  position:absolute;
  left:0;
  top:0;
  z-index:100;
  cursor:not-allowed;
 }
 .remove_scheduling_tab .wizard-navigation ul.wizard-nav li:nth-child(2) *{
  position:static;
  z-index: 1;
 }
 .remove_scheduling_tab .wizard-navigation ul.wizard-nav li:nth-child(2) .wizard-icon-circle{
  border: 3px solid #f3f2ee;
  border-radius: 50%;
  background-color: #fff;
  color:rgba(0,0,0,0.2);
 }
 .remove_scheduling_tab .wizard-navigation ul.wizard-nav li:nth-child(2) .wizard-icon-circle .stepTitle {
  color:rgba(0,0,0,0.2);
 }
</style>
